import ShopManagerLayout from './ShopManagerLayout';

export default ShopManagerLayout;
